export enum FoldersApiActionTypes {
  AddedSuccess = '[Folders API] Added Success',
  AddedFailure = '[Folders API] Added Failure',

  UpdatedSuccess = '[Folders API] Updated Success',
  UpdatedFailure = '[Folders API] Updated Failure',

  DeletedSuccess = '[Folders API] Deleted Success',
  DeletedFailure = '[Folders API] Deleted Failure',

  ClientFoldersLoadedSuccess = '[Folders API] Client Folders Loaded Success',
  ClientFoldersLoadedFailure = '[Folders API] Client Folders Loaded Failure',
}
